<nx-link [attr.class]="this.class">
  <a
    (click)="linkClicked($event)"
    [ngClass]="{ 'disabled-link': disabled }"
    href=""
    [attr.data-cy]="this.dataCy + '-link' + (disabled ? '-disabled' : '')">
    <nx-icon
      [name]="this.icon"
      aria-hidden="true"></nx-icon>
    <ng-content></ng-content>
    {{ this.text }}
    @if (indicator) {
      <nx-indicator
        position="over-text"
        [attr.aria-label]="indicatorAriaLabel"></nx-indicator>
    }
  </a>
</nx-link>
